import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, from, of } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OneUIService {
  apiURL = environment.apiURL;

  constructor(private http: HttpClient) { }


  clearUserRecord(): Observable<any> {
    return this.http.get(`${this.apiURL}/chat-bot-clear`);
  }

  userFileStatus(): Observable<any> {
    return this.http.get(`${this.apiURL}/chat-uploads-status`);
  }

  uploadUserFile(payload: any): Observable<any> {
    return this.http.post(`${this.apiURL}/chat-uploads`, payload);
  }

  chatStreamBot(payload: any): Observable<any> {
    return this.http.post(`${this.apiURL}/chat-bot-stream`, payload);
  }


}
